import { NOTE_COLORS, type NoteColor } from '@shared/types'
import { noteColorVars } from '@/state/notes-context'

export function ColourPicker({ value, onChange }: { value: NoteColor; onChange: (color: NoteColor) => void }) {
  return <div className="colour-grid" role="group" aria-label="Colour">
    {(Object.keys(NOTE_COLORS) as NoteColor[]).map((color) => <button key={color} type="button" className={`color-swatch ${value === color ? 'selected' : ''}`} style={noteColorVars(color)} onClick={() => onChange(color)} aria-label={NOTE_COLORS[color].label} aria-pressed={value === color} />)}
  </div>
}
